// Displacement goes along the surface normal so it works on every shape
// Prepended to every vertex effect. Each effect file defines:
//   vec3 displace(vec3 pos, vec2 uv, inout float elevation)
uniform sampler2D uTexture;
uniform float uTime;
uniform float uStrength;
uniform float uFrequency;
uniform float uSpeed;
uniform bool uMirror;
uniform vec2 uResolution;   // webcam size in pixels
uniform float uSegments;    // plane subdivisions, so effects know the vertex spacing
uniform float uPointSize;
uniform float uPixelRatio;

varying vec2 vUv;
varying float vElevation;

float luma(vec3 c)
{
    return dot(c, vec3(0.299, 0.587, 0.114));
}

vec3 sampleCam(vec2 uv)
{
    if(uMirror) uv.x = 1.0 - uv.x;
    return texture2D(uTexture, uv).rgb;
}
